<template>
    <v-app id="app">
        <div>
            <navigation-menu class="navigation-menu" color="111111"></navigation-menu>
            <div class="appcontent" ref="appContent">
                <widget-cards-buffer/>
                <div v-if="!$store.getters.isAuthenticated">
                    <div class="container h-100 pt-5">
                        <div class="row h-100 justify-content-center align-items-center">
                            <div class="col-8">
                                <div class="border border-secondary p-3 text-center">
                                    <h1 class="display-4">{{ $t("app.lbl_title") }}</h1>
                                    <div>
                                        <span class="mdi mdi-loading mdi-spin"></span>
                                        <span>{{ $t("app.lbl_text") }}</span>
                                        <div class="mt-2">
                                            <span class="mdi mdi-loading mdi-spin"
                                                  v-if="$store.getters.isBackLogin"></span>
                                            <span class="mdi mdi-signal"
                                                  v-if="!$store.getters.isBackLogin"></span>
                                            <span>{{ $t("app.lbl_back_login") }}</span>
                                        </div>
                                        <div v-if="$store.getters.isLoginError"
                                             class="text-primary">
                                            <span class="mdi mdi-alert-circle-outline"></span>
                                            <span>{{ $t("app.lbl_error_login") }}</span>
                                        </div>
                                        <div class="mt-1">
                                            <button class="btn btn-outline-primary"
                                                    @click="fnLogout()">
                                                LogOut &amp; Clean
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="page">
                    <transition name="slide" mode="out-in">
                        <router-view v-slot="{ Component }">
                            <component :is="Component" />
                        </router-view>
                    </transition>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
    import NavigationMenu from "@/shared/components/home/NavigationMenu.vue";
    import WidgetCardsBuffer from "@/shared/components/home/WidgetCardsBuffer.vue";

    export default {
        name: "app",
        data: function () {
            return {};
        },
        components: { NavigationMenu, WidgetCardsBuffer },
        methods: {
            fnLogout: function () {
                this.$store.dispatch("Logout");
            },
        },
    };
</script>
<style>

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    .page-title {
        font-family: "iris-medium";
        text-align: left
    }
    .navigation-menu {
        z-index: 1040;
    }

    .appcontent {
        height: calc(100vh - 40px);
        background-color: #fbfbfb;
        overflow-x: scroll;
        scroll-margin: 100px;
        scroll-behavior: smooth;
    }


        .appcontent::-webkit-scrollbar-track {
            width: 15px
        }

        .appcontent::-webkit-scrollbar {
            height: 8px;
            width: 10px;
            background-color: transparent;
        }

        .appcontent::-webkit-scrollbar-thumb {
            border-radius: 20px;
            width: 4px;
            background-color: var(--jll-dark-red-08);
            cursor: pointer;
        }

            .appcontent::-webkit-scrollbar-thumb:hover {
                background-color: var(--jll-dark-red-08);
            }

        .appcontent::-webkit-scrollbar-track:hover {
            -webkit-box-shadow: inset 0.3px 0 2px rgba(0, 0, 0, 0.2);
            border-radius: 20px;
        }


    .slide-leave-active {
        transition: opacity 0s, transform 0s;
    }
    .slide-enter-active {
        transition: opacity 0.2s, transform 0.2s;
    }

    .slide-enter {
        transform: translateY(0.6vh);
        opacity: 0;
    }

    .slide-leave-to {
        transform: translateY(0.6v h);
        opacity: 0;
    }

    .div-slider {
        overflow: hidden;
        position: relative;
        height: 100px;
        width: 90%;
    }
</style>
